import Vue from 'vue'
import VueI18n from "vue-i18n";
import App from './App.vue'
import 'amfe-flexible'
import { Dialog } from "vant";
import "@/assets/style/index.styl"
import "vant/lib/index.css";
import "vant/lib/icon/local.css";

Vue.config.productionTip = false

//国际化
initI18n();
function initI18n() {
    // 通过选项创建 VueI18n 实例
    Vue.use(VueI18n);
    const i18n = new VueI18n({
        locale: "en", // 设置地区
        messages: {
            en: require("./assets/lang/en"), // 英文语言包
            vi: require("./assets/lang/vi"), // 越南语言包
            id: require("./assets/lang/id"), // 印尼语言包
            ms: require("./assets/lang/ms"), // 马来语言包
            pt: require("./assets/lang/pt"), // 葡萄牙语言包
            ar: require("./assets/lang/ar"), // 阿拉伯语言包
            es: require("./assets/lang/es"), // 西班牙语言包
            hi: require("./assets/lang/hi"), // 印地语语言包
            tr: require("./assets/lang/tr"), // 土耳其语语言包
            fr: require("./assets/lang/fr"), // 法语语言包
            de: require("./assets/lang/de"), // 德语语言包
            ru: require("./assets/lang/ru"), // 俄罗斯语语言包
            th: require("./assets/lang/th"), // 泰语语言包
            ja: require("./assets/lang/ja"), // 日语语言包
            ko: require("./assets/lang/ko"), // 韩语语言包
            bn: require("./assets/lang/bn"), // 孟加拉语语言包
            ur: require("./assets/lang/ur") // 乌尔都语语言包
        }
    });
    window.i18n = i18n;
}

Vue.use(Dialog)

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
